import i18n from '../i18n';
import {ErrorEvent} from './network';

export const unknownError = new ErrorEvent({message: i18n.t('Unknown error')});

export default unknownError;